import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useConfig } from "../../context/ConfigContext";
import { isDesktop } from "react-device-detect";
import { useTranslation } from "react-i18next";
import { DesktopPage } from "./DesktopPage";
import { CircularProgress } from "@mui/material";
import { MobilePage } from "./MobilePage";

export const WelcomePage = ({ onFinish, onGeoBlock }) => {
  const { t } = useTranslation(["homeModule"]);
  const { initializeConfig } = useConfig();
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  // Get necessary files
  // Attempt to initialize configuration with customerName from env or default
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    let customerName;

    function removeParam() {
      if (params.get("customerName")) {
        params.delete("customerName");
        // Update the URL without reloading the page
        navigate(
          {
            pathname: window.location.pathname,
            search: params.toString(),
          },
          { replace: true },
        );
      }
    }

    if (
      !process.env.REACT_APP_DEFAULT_CUSTOMER_NAME ||
      process.env.REACT_APP_DEFAULT_CUSTOMER_NAME === ""
    ) {
      customerName = params.get("customerName") || "techdemo";
    } else {
      // Remove param if the value comes from .env
      customerName = process.env.REACT_APP_DEFAULT_CUSTOMER_NAME;
      removeParam();
    }

    initializeConfig(customerName, isDesktop).then((res) => {
      if (res.response) {
        res.geoStatus && onGeoBlock();
        setIsLoading(false);
      } else {
        removeParam();
      }
    });
  }, [initializeConfig, navigate]);

  return (
    <>
      {isLoading ? (
        <div className="home-loading-page">
          <CircularProgress
            disableShrink
            color="inherit"
            size={40}
            thickness={4}
          />
          <p className="loading-text">{t("initializing")}</p>
        </div>
      ) : isDesktop ? (
        <DesktopPage />
      ) : (
        <MobilePage onFinish={onFinish} />
      )}
    </>
  );
};
